import script from "./valgteFilm.vue?vue&type=script&setup=true&lang=js"
export * from "./valgteFilm.vue?vue&type=script&setup=true&lang=js"

import "./valgteFilm.vue?vue&type=style&index=0&id=451347fd&lang=css"

const __exports__ = script;

export default __exports__